import { useAPIGetActiveSelection } from 'api/selection/useAPISelection'
import { useAPIGetStatusUsulan } from 'api/usulan/useAPIUsulan'
import { queryClient } from 'pages/_app'

import { useRegionContext } from 'utils/hooks/useRegion'

const useActiveSelection = () => {
  const { regionDetail } = useRegionContext()
  const {
    data: activeSelection,
    isLoading: isLoadingActiveSelection,
    refetch: refetchActiveSelection,
  } = useAPIGetActiveSelection(
    {
      regionId: regionDetail.id,
      regionType: regionDetail.type,
    },
    {
      onError() {
        // Remove query data when user finalizes the current KS Selection (active KS Selection API returns 404)
        if (queryClient.getQueryData('getActiveKSSelection')) {
          queryClient.removeQueries({ queryKey: 'getActiveKSSelection' })
        }
      },
    }
  )

  const selectionStateShouldGetUsulan =
    activeSelection?.state === 'PENGUSULAN_BKN' ||
    (activeSelection?.state === 'FINALIZATION' &&
      activeSelection?.statusPejabat === 'PJ')

  const { data: usulan, isLoading: isLoadingStatusUsulan } =
    useAPIGetStatusUsulan('seleksi-kepala-sekolah', activeSelection?.id, {
      queryConfig: {
        enabled: !!activeSelection?.id && selectionStateShouldGetUsulan,
      },
    })

  return {
    refetchActiveSelection,
    activeSelection,
    isLoadingActiveSelection: isLoadingActiveSelection || isLoadingStatusUsulan,
    usulan,
  }
}

export default useActiveSelection
